import { render, staticRenderFns } from "./tweetHome.vue?vue&type=template&id=5b96958e&scoped=true"
import script from "./tweetHome.vue?vue&type=script&lang=js"
export * from "./tweetHome.vue?vue&type=script&lang=js"
import style0 from "./tweetHome.vue?vue&type=style&index=0&id=5b96958e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96958e",
  null
  
)

export default component.exports